<ng-container *ngIf="!extension">
  <ng-container [ngSwitch]="mode">
    <img
      *ngSwitchCase="'probing'"
      [src]="url"
      loading="lazy"
      class="img-preview img-probing"
      (load)="onProbeResult('image')"
      (error)="onProbeResult('link')"
    />

    <img *ngSwitchCase="'image'" [src]="url" loading="lazy" class="img-preview mb-2 clickable" />

    <a *ngSwitchCase="'link'" [href]="url" target="_blank" rel="noopener noreferrer">{{ url }}</a>

    <span *ngSwitchDefault>{{ url }}</span>
  </ng-container>

  <!-- <img
    [src]="url"
    class="img-preview mb-2 clickable"
    *ngIf="loadedImages.includes(url)"
    (click)="onOpenImage(url)"
  />
  <div *ngIf="!loadedImages.includes(url)">
    <a [href]="url" target="_blank">{{ url }}</a>
  </div> -->
</ng-container>

<ng-container *ngIf="extension">
  <ng-container *ngIf="mimeType.includes('image'); else defaultFileLinkTmpl">
    <img [src]="url" class="img-preview mb-2 clickable" (click)="onOpenImage(url)" />
  </ng-container>
</ng-container>

<ng-template #defaultFileLinkTmpl>
  <div (click)="onOpenImage(url)" class="clickable">
    <div class="file-preview bg-light">
      <div class="d-flex justify-content-center align-items-center h-100">
        <img [src]="'assets/images/file-icons/' + extension + '.svg'" alt="icon" class="icon-preview" />
      </div>
    </div>
    <div class="card file-preview-footer p-1 font-11 mb-0">
      {{ fileName }}
    </div>
  </div>
</ng-template>
